// extracted by mini-css-extract-plugin
export default {"timerAnimation":"Timer_timerAnimation__GA-wb","timeText":"Timer_timeText__fA8Ey"};